import { createTheme } from "@mui/material/styles";

// ── Palette « luxe doux » ─────────────────────────────────────
// Ivoire, champagne, or chaud, eucalyptus, gris chaud. Aucune couleur saturée.
export const palette = {
  ivory: "#FAF6EF",
  ivoryDeep: "#F3ECE1",
  champagne: "#E7D8C4",
  gold: "#BFA06A",
  goldDeep: "#A8884F",
  eucalyptus: "#8A9A8B",
  warmGray: "#6B6259",
  ink: "#3A352F",
  line: "rgba(58,53,47,0.14)",
};

// Familles typographiques
export const fonts = {
  display: '"Playfair Display", Georgia, serif', // titres
  serif: '"Cormorant Garamond", Georgia, serif', // corps élégant
  script: '"Great Vibes", cursive', // prénoms / accents romantiques
  sans: '"Inter", "Helvetica Neue", Arial, sans-serif', // UI / labels
};

const theme = createTheme({
  palette: {
    primary: { main: palette.gold, dark: palette.goldDeep },
    secondary: { main: palette.eucalyptus },
    background: { default: palette.ivory, paper: "#FFFFFF" },
    text: { primary: palette.ink, secondary: palette.warmGray },
  },
  typography: {
    fontFamily: fonts.serif,
    h1: { fontFamily: fonts.display, fontWeight: 600 },
    h2: { fontFamily: fonts.display, fontWeight: 600 },
    h3: { fontFamily: fonts.display, fontWeight: 600 },
    h4: { fontFamily: fonts.display, fontWeight: 600 },
    h5: { fontFamily: fonts.display, fontWeight: 600 },
    button: { fontFamily: fonts.sans, textTransform: "none", letterSpacing: "0.12em" },
    overline: { fontFamily: fonts.sans, letterSpacing: "0.3em" },
  },
  shape: { borderRadius: 10 },
});

export default theme;
